// ** Redux
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import selectorActivator from "./selectorActivator";

// #####################################################

const SelectorDay = ({ selectorDay, onAccept }) => {
	const { t } = useTranslation(["common", "pages", "landing"]);

	const isOpenInAuthModal = useSelector(
		(state) => state.globalCommon.authModal.isOpen
	);

	const {
		items: selectorDayItems,
		selected: selectorDaySelected,
		setSelected: selectorDaySetSelected,
		isSelected: selectorDayIsSelected,
	} = selectorDay || {};

	// #####################################################

	return (
		<Block mr={1.2} flex full>
			<SelectorSelectSingle
				label={t("landing:register.selectDay")}
				emptyText={t("landing:register.dayPlaceholder")}
				items={selectorDayItems}
				selected={selectorDaySelected}
				onAccept={(value) => {
					selectorDaySetSelected(value);
					onAccept(value);
				}}
				customActivator={({
					label,
					innerRef,
					toggle,
					isOpen,
					disabled,
					contentToDisplay,
				}) =>
					selectorActivator({
						label,
						triggerRef: innerRef,
						toggle,
						isOpen,
						disabled,
						displayText: contentToDisplay,
						hasSelected: selectorDayIsSelected,
						style: {
							width: "100%",
							borderTopRightRadius: "0px",
							borderBottomRightRadius: "0px",
							borderRightWidth: 0,
							marginRight: "0px",
						},
						alwaysLight: true,
					})
				}
				withMobileVersion
				maxLayerHeight={280}
				activatorStyleOptions={{
					flex1: true,
					noBold: true,
					noPad: true,
					hideLabel: true,
					isLanding: true,
				}}
				alwaysLight
				isLanding
				menuFontSize="1.1rem"
				closeWithoutEnableScroll={isOpenInAuthModal}
			/>
		</Block>
	);
};

// #####################################################

export default SelectorDay;

// #####################################################
